const judgeTokenExp = async ({ dispatch, rootState }) => {
  const expiryTime = rootState.user.expiryTime * 1000
  const isExpiry = new Date().getTime() + 60 * 1000 > expiryTime
  if (isExpiry) {
    // console.log('====isExpiry====')
    await dispatch('GET_TOKEN')
  }
}
export default judgeTokenExp



// WEBPACK FOOTER //
// ./src/util/judgeTokenExp.js